import { Component, input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import {
  AUTO_STYLE,
  animate,
  state,
  style,
  transition,
  trigger,
} from '@angular/animations';

import { OfferDescriptionComponent } from '../../components/offer-description/offer-description.component';
import { OfferAbilitiesComponent } from '../../components/offer-abilities/offer-abilities.component';
import { OfferProsComponent } from '../../components/offer-pros/offer-pros.component';
import { OfferHowComponent } from '../../components/offer-how/offer-how.component';
import { OfferTechComponent } from '../../components/offer-tech/offer-tech.component';
import { OfferForComponent } from '../../components/offer-for/offer-for.component';
import { OfferCheckComponent } from '../../components/offer-check/offer-check.component';
import { NgClass } from '@angular/common';

const DEFAULT_DURATION = 300;

@Component({
  selector: 'app-offer',
  standalone: true,
  imports: [
    TranslateModule,
    OfferDescriptionComponent,
    OfferAbilitiesComponent,
    OfferProsComponent,
    OfferHowComponent,
    OfferTechComponent,
    OfferForComponent,
    OfferCheckComponent,
    NgClass,
  ],
  templateUrl: './offer.component.html',
  styleUrl: './offer.component.css',
  animations: [
    trigger('collapse', [
      state('false', style({ height: AUTO_STYLE, visibility: AUTO_STYLE })),
      state('true', style({ height: '0', visibility: 'hidden' })),
      transition('false => true', animate(DEFAULT_DURATION + 'ms ease-in')),
      transition('true => false', animate(DEFAULT_DURATION + 'ms ease-out')),
    ]),
  ],
})
export class OfferComponent {
  offerTitle = input.required<string>();

  //z offer description
  descHeaderHighlight = input<string>();
  descHeaderHighlight1 = input<string>();
  descHeader = input<string>();
  descText1 = input<string>();
  descText2 = input<string>();
  descLogo1 = input<{ src: string; alt: string; link: string }>();
  descLogo2 = input<{ src: string; alt: string; link: string }>();
  descLogo3 = input<{ src: string; alt: string; link: string }>();
  descLogo4 = input<{ src: string; alt: string; link: string }>();
  descLogo5 = input<{ src: string; alt: string; link: string }>();
  descHeaderHighlightA = input<string>();
  descHeaderHighlight1A = input<string>();
  descHeaderA = input<string>();
  descText1A = input<string>();
  descText2A = input<string>();
  descLogo1A = input<{ src: string; alt: string; link: string }>();
  descLogo2A = input<{ src: string; alt: string; link: string }>();
  descLogo3A = input<{ src: string; alt: string; link: string }>();
  descLogo4A = input<{ src: string; alt: string; link: string }>();
  descLogo5A = input<{ src: string; alt: string; link: string }>();
  descHeaderHighlightB = input<string>();
  descHeaderHighlight1B = input<string>();
  descHeaderB = input<string>();
  descText1B = input<string>();
  descText2B = input<string>();
  descLogo1B = input<{ src: string; alt: string; link: string }>();
  descLogo2B = input<{ src: string; alt: string; link: string }>();
  descLogo3B = input<{ src: string; alt: string; link: string }>();
  descLogo4B = input<{ src: string; alt: string; link: string }>();
  descLogo5B = input<{ src: string; alt: string; link: string }>();

  //z offer abil
  abilHeaderHighlight = input<string>();
  abilHeader = input<string>();
  abilBold1 = input<string>();
  abilText1 = input<string>();
  abilBold2 = input<string>();
  abilText2 = input<string>();
  abilBold3 = input<string>();
  abilText3 = input<string>();
  abilBold4 = input<string>();
  abilText4 = input<string>();
  abilBold5 = input<string>();
  abilText5 = input<string>();
  abilHeaderHighlightA = input<string>();
  abilHeaderA = input<string>();
  abilBold1A = input<string>();
  abilText1A = input<string>();
  abilBold2A = input<string>();
  abilText2A = input<string>();
  abilBold3A = input<string>();
  abilText3A = input<string>();
  abilBold4A = input<string>();
  abilText4A = input<string>();
  abilBold5A = input<string>();
  abilText5A = input<string>();
  abilHeaderHighlightB = input<string>();
  abilHeaderB = input<string>();
  abilBold1B = input<string>();
  abilText1B = input<string>();
  abilBold2B = input<string>();
  abilText2B = input<string>();
  abilBold3B = input<string>();
  abilText3B = input<string>();
  abilBold4B = input<string>();
  abilText4B = input<string>();
  abilBold5B = input<string>();
  abilText5B = input<string>();

  //z offer pros
  //prosHeaderHighlight = input.required<string>();
  prosHeader = input<string>();
  prosBold1 = input<string>();
  prosText1 = input<string>();
  prosBold2 = input<string>();
  prosText2 = input<string>();
  prosBold3 = input<string>();
  prosText3 = input<string>();
  prosBold4 = input<string>();
  prosText4 = input<string>();
  prosHeaderA = input<string>();
  prosBold1A = input<string>();
  prosText1A = input<string>();
  prosBold2A = input<string>();
  prosText2A = input<string>();
  prosBold3A = input<string>();
  prosText3A = input<string>();
  prosBold4A = input<string>();
  prosText4A = input<string>();
  prosHeaderB = input<string>();
  prosBold1B = input<string>();
  prosText1B = input<string>();
  prosBold2B = input<string>();
  prosText2B = input<string>();
  prosBold3B = input<string>();
  prosText3B = input<string>();
  prosBold4B = input<string>();
  prosText4B = input<string>();

  //z offer how
  //howHeaderHighlight = input.required<string>();
  howHeader = input<string>();
  howBold1 = input<string>();
  howText1 = input<string>();
  howBold2 = input<string>();
  howText2 = input<string>();
  howBold3 = input<string>();
  howText3 = input<string>();
  howBold4 = input<string>();
  howText4 = input<string>();
  howHeaderA = input<string>();
  howBold1A = input<string>();
  howText1A = input<string>();
  howBold2A = input<string>();
  howText2A = input<string>();
  howBold3A = input<string>();
  howText3A = input<string>();
  howBold4A = input<string>();
  howText4A = input<string>();
  howHeaderB = input<string>();
  howBold1B = input<string>();
  howText1B = input<string>();
  howBold2B = input<string>();
  howText2B = input<string>();
  howBold3B = input<string>();
  howText3B = input<string>();
  howBold4B = input<string>();
  howText4B = input<string>();

  //z offer tech
  //techHeaderHighlight = input.required<string>();
  techHeader = input<string>();
  techBold1 = input<string>();
  techText1 = input<string>();
  techBold2 = input<string>();
  techText2 = input<string>();
  techBold3 = input<string>();
  techText3 = input<string>();
  techBold4 = input<string>();
  techText4 = input<string>();
  techHeaderA = input<string>();
  techBold1A = input<string>();
  techText1A = input<string>();
  techBold2A = input<string>();
  techText2A = input<string>();
  techBold3A = input<string>();
  techText3A = input<string>();
  techBold4A = input<string>();
  techText4A = input<string>();
  techHeaderB = input<string>();
  techBold1B = input<string>();
  techText1B = input<string>();
  techBold2B = input<string>();
  techText2B = input<string>();
  techBold3B = input<string>();
  techText3B = input<string>();
  techBold4B = input<string>();
  techText4B = input<string>();

  //z offer for
  forHeader = input<string>();
  forSubheader = input<string>();
  forText1 = input<string>();
  forText2 = input<string>();
  forText3 = input<string>();
  forText4 = input<string>();
  forBold1 = input<string>();
  forBold2 = input<string>();
  forBold3 = input<string>();
  forBold4 = input<string>();
  forHeaderA = input<string>();
  forText1A = input<string>();
  forText2A = input<string>();
  forText3A = input<string>();
  forText4A = input<string>();
  forBold1A = input<string>();
  forBold2A = input<string>();
  forBold3A = input<string>();
  forBold4A = input<string>();
  forHeaderB = input<string>();
  forText1B = input<string>();
  forText2B = input<string>();
  forText3B = input<string>();
  forText4B = input<string>();
  forBold1B = input<string>();
  forBold2B = input<string>();
  forBold3B = input<string>();
  forBold4B = input<string>();

  //z offer check
  checkHeader = input<string>();
  checkBold1 = input<string>();
  checkText1 = input<string>();
  checkLink1 = input<string>();
  checkBold2 = input<string>();
  checkText2 = input<string>();
  checkLink2 = input<string>();
  checkHeaderA = input<string>();
  checkBold1A = input<string>();
  checkText1A = input<string>();
  checkLink1A = input<string>();
  checkBold2A = input<string>();
  checkText2A = input<string>();
  checkLink2A = input<string>();
  checkHeaderB = input<string>();
  checkBold1B = input<string>();
  checkText1B = input<string>();
  checkLink1B = input<string>();
  checkBold2B = input<string>();
  checkText2B = input<string>();
  checkLink2B = input<string>();

  //zmienne do pokazywania fragmentów oferty
  collapsed = true;
  arrowed = true;
  arrowedInactive = false;
  collapsed1 = true;
  arrowed1 = true;
  arrowedInactive1 = false;
  collapsedA = true;
  arrowedA = true;
  arrowedInactiveA = false;
  collapsedB = true;
  arrowedB = true;
  arrowedInactiveB = false;
  desc = true;
  abil = false;
  pros = false;
  how = false;
  tech = false;
  for = false;
  check = false;
  descA = true;
  abilA = false;
  prosA = false;
  howA = false;
  techA = false;
  forA = false;
  checkA = false;
  descB = true;
  abilB = false;
  prosB = false;
  howB = false;
  techB = false;
  forB = false;
  checkB = false;

  falseAll() {
    this.desc = false;
    this.abil = false;
    this.pros = false;
    this.how = false;
    this.tech = false;
    this.for = false;
    this.check = false;
  }
  falseAllA() {
    this.descA = false;
    this.abilA = false;
    this.prosA = false;
    this.howA = false;
    this.techA = false;
    this.forA = false;
    this.checkA = false;
  }
  falseAllB() {
    this.descB = false;
    this.abilB = false;
    this.prosB = false;
    this.howB = false;
    this.techB = false;
    this.forB = false;
    this.checkB = false;
  }

  toggle() {
    this.collapsed = !this.collapsed;
    this.arrowed = !this.arrowed;
    this.arrowedInactive = !this.arrowedInactive;
  }
  toggle1() {
    this.collapsed1 = !this.collapsed1;
    this.arrowed1 = !this.arrowed1;
    this.arrowedInactive1 = !this.arrowedInactive1;
  }
  toggleA() {
    this.collapsedA = !this.collapsedA;
    this.arrowedA = !this.arrowedA;
    this.arrowedInactiveA = !this.arrowedInactiveA;
  }
  toggleB() {
    this.collapsedB = !this.collapsedB;
    this.arrowedB = !this.arrowedB;
    this.arrowedInactiveB = !this.arrowedInactiveB;
  }

  expand() {
    this.collapsed = false;
    this.arrowed = false;
    this.arrowedInactive = true;
  }

  collapse() {
    this.collapsed = true;
    this.arrowed = true;
    this.arrowedInactive = false;
  }

  description() {
    this.falseAll();
    this.desc = true;
  }

  abilities() {
    this.falseAll();
    this.abil = true;
  }

  prosfun() {
    this.falseAll();
    this.pros = true;
  }

  howfun() {
    this.falseAll();
    this.how = true;
  }

  techfun() {
    this.falseAll();
    this.tech = true;
  }

  forfun() {
    this.falseAll();
    this.for = true;
  }

  checkfun() {
    this.falseAll();
    this.check = true;
  }
  descriptionA() {
    this.falseAllA();
    this.descA = true;
  }

  abilitiesA() {
    this.falseAllA();
    this.abilA = true;
  }

  prosfunA() {
    this.falseAllA();
    this.prosA = true;
  }

  howfunA() {
    this.falseAllA();
    this.howA = true;
  }

  techfunA() {
    this.falseAllA();
    this.techA = true;
  }

  forfunA() {
    this.falseAllA();
    this.forA = true;
  }

  checkfunA() {
    this.falseAllA();
    this.checkA = true;
  }
  descriptionB() {
    this.falseAllB();
    this.descB = true;
  }

  abilitiesB() {
    this.falseAllB();
    this.abilB = true;
  }

  prosfunB() {
    this.falseAllB();
    this.prosB = true;
  }

  howfunB() {
    this.falseAllB();
    this.howB = true;
  }

  techfunB() {
    this.falseAllB();
    this.techB = true;
  }

  forfunB() {
    this.falseAllB();
    this.forB = true;
  }

  checkfunB() {
    this.falseAllB();
    this.checkB = true;
  }
}
